import { Toast, setToastAfterReload } from '../../state/toastStore';
import { useAuthStore } from '../../state/authStore';
import { useIntercom } from '../useIntercom';
import { useNPS } from '../useNPS';

/**
 * Signs the user out and clears what outlives the auth store: learn-app's last-active marker, the
 * Intercom session (its cookie would hand the next person on this browser the previous user's
 * conversations) and the NPS init guard. logout() then hard-navigates to /login, so a toast
 * passed here is carried across that load.
 *
 * Keep every step idempotent: useAccessHelper.isAllowed calls this during render, once per gated
 * allowance, so one render can run it many times before the navigation lands.
 */
export const useEndSession = () => {
  const { logout } = useAuthStore();
  const { intercomShutdown } = useIntercom();
  const { removeNPS } = useNPS();

  return (toast?: Toast) => {
    if (toast) {
      setToastAfterReload(toast);
    }

    localStorage.setItem('last_active', '');

    intercomShutdown();

    removeNPS();

    logout();
  };
};
